import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { HeaderFlags, FooterMode } from '@/store/ui';
import { OrderWithContext, CustomerDeliveryAddress, DeliveryEstimate } from '@/models';
import { getEntreeCount } from '../../components/checkout/CmgCheckout/cmg-checkout-helpers';
import { CheckoutEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgCheckoutPage',
  beforeRouteLeave(to, from, next) {
    this.$services.ui.popHeaderState();
    this.$services.ui.popFooterState();

    next();
  },
})
export default class CmgCheckoutPage extends Vue {
  currentOrder: OrderWithContext | null = null;
  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get isPickup(): boolean {
    return this.$services.order.isPickingUp();
  }

  get deliveryAddress(): CustomerDeliveryAddress | null {
    return this.$appStore.state.order.selectedDeliveryAddress;
  }

  get isDeliveryFree(): boolean | null {
    if (this.isPickup) {
      return null;
    }

    const order = this.$services.order.getCurrentOrder();

    return (order && order.order.deliveryFeeObtained && order.order.delivery && order.order.delivery.feeAmount === 0) || false;
  }

  get deliveryEstimate(): DeliveryEstimate | null {
    return this.$appStore.state.checkout.delivery.estimate;
  }

  get pickupTimes(): string {
    return this.$appStore.state.checkout.pickup.availablePickupTimes[0] ;
  }

  private watchers: (() => void)[] = [];

  processOrderDiscountErrors(order: OrderWithContext, promoCode: string) {
    return this.$services.order.processOrderDiscountErrors(order, promoCode);
  }

  @Watch('deliveryAddress', { immediate: true })
  async onDeliveryAddressChanged(address: CustomerDeliveryAddress | null) {
    await this.$services.checkout.refreshDeliveryInfo();
    if (this.deliveryAddress && !this.isPickup) {
      Vue.nextTick(() => {
        setTimeout(() => {
          this.$services.analytics.send(new CheckoutEvent());
        }, 1000);
      });
    }
  }

  async mounted() {
    this.$services.ui.pushHeaderState({
      flags: HeaderFlags.All & ~HeaderFlags.LogoVisibleXS & ~HeaderFlags.MenuNav & ~HeaderFlags.FindChipotleLeft & ~HeaderFlags.Bag,
      route: '/#menu',
      routeText: 'Return to Menu',
    });
    this.$services.ui.pushFooterState({ mode: FooterMode.None });

    await this.refreshAvailablePickupTimes();

    // if order is for pickup, after pickup times are refreshed, send scCheckoutEVent
    if (this.isPickup) {
      this.$services.analytics.send(new CheckoutEvent());
    }
    
    this.$services.transaction.refreshPaymentCards();

    this.watchers.push(this.$appStore.watch(s => s.restaurant.selectedRestaurant, this.onRestaurantUpdated));
  }

  destroyed() {
    for (const desubFn of this.watchers) {
      desubFn();
    }
  }

  private onRestaurantUpdated() {
    this.refreshAvailablePickupTimes();
  }

  private async refreshAvailablePickupTimes(): Promise<void> {
    const order = this.order;
    if (!order) {
      // TODO-wn396t: what do?
      return;
    }

    this.$services.ui.incrementLoader('pickupTimes');
    try {
      this.$services.checkout.setAvailablePickupTimes(await this.$services.sput.getPickupTimesForRestaurant(order.order.restaurantId, getEntreeCount(order.order)));
    } catch {
      this.$services.checkout.setAvailablePickupTimes([]);
    }
    this.$services.ui.decrementLoader('pickupTimes');
  }
}
